import IInitializableModule from '@episerver/spa-core/Core/IInitializableModule';
import IServiceContainer from '@episerver/spa-core/Core/IServiceContainer';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import IStateReducerInfo from '@episerver/spa-core/Core/IStateReducerInfo';
import volteCheckSliceReducer from './VolteCheckSlice';

export default class VolteCheckInitializable implements IInitializableModule {
  protected name: string = 'volte check component';

  public GetName(): string {
    return this.name;
  }

  public ConfigureContainer(container: IServiceContainer): void {}

  public StartModule(context: IEpiserverContext): void {}

  public GetStateReducer(): IStateReducerInfo<any> | null {
    return {
      stateKey: 'volteCheckSlice',
      reducer: volteCheckSliceReducer,
    };
  }
}
